import { Primary } from '@decorators/entity-primary.decorator';
import { Required } from '@decorators/entity-required.decorator';
import { KeepProperty } from '@decorators/entity-keepproperty.decorator';

import { v4 as uuidv4 } from 'uuid';

import { Entity } from './entity.class';
import { PhraseCategory } from './phrase-category.class';
import { PhraseDommage } from './phrase-dommage.class';

import { Question } from './question.class';
import { PhraseVersion } from './phrase-version.class';
import { PhraseWorkflow } from './phrase-workflow.class';

export enum PhraseType {
	QUESTION = 'question',
	TITLE = 'title',
	SUBTITLE = 'subtitle',
	FORCED = 'forced',
	CONCLUSION_RED = 'conclusion_red',
	CONCLUSION_BLUE = 'conclusion_blue'
}


export class Phrase implements Entity {
	@Required
	@Primary
	id: number;

	@Required
	uuid: string;

	/**
	 * Label court pour identification rapide de la phrase
	 * Utile pour les listes et la recherche
	 */
	label?: string;

	@Required
	text: string;

	@KeepProperty
	overrides?: Record<string, string>;

	@Required
	isActive: boolean = true;

	version?: PhraseVersion;

	@Required
	hasPhoto: boolean = false;

	@Required
	type: PhraseType;

	questions?: Question[];

	@KeepProperty
	preconisations?: Question[];

	@KeepProperty
	remarques?: Question[];
	category?: PhraseCategory;
	dommages?: PhraseDommage[];
	versionId?: number;

	// ========================================
	// NOUVEAU SYSTÈME WORKFLOW
	// ========================================

	/**
	 * Indique si cette phrase utilise le nouveau système de workflow
	 */
	useNewBuilder?: boolean;

	/**
	 * ID du workflow actif actuel (type MAIN)
	 */
	currentWorkflowId?: number;

	/**
	 * Workflow actif (eager loaded si besoin)
	 */
	currentWorkflow?: PhraseWorkflow;

	// ========================================

	constructor() {
		if (!this.uuid)
			this.uuid = uuidv4();
	}

	/**
	 * Vérifie si cette phrase doit utiliser le nouveau système workflow
	 */
	hasActiveWorkflow(): boolean {
		return !!this.useNewBuilder && !!this.currentWorkflowId;
	}
}
